// #region CONSTANTES
// Clé API
export const API_DEV_KEY = "AIzaSyCI6iCv6jssgp_KmJToFq31dOIQPw1d3rk"; // Clé de dev
// export const API_KEY = "AIzaSyCnpfjxyQDPe31o5pV6Tp02b0CD8Noo6Ss"; // Ancienne clé de prod
export const API_KEY = "AIzaSyBg9ylCnhWMyFQzP6BEAY1zoghZnQt6NwA"; // Nouvelle clé de prod

// Niveau de zoom
export const ZOOM_COUNTRY = 5;
export const ZOOM_CITY = 12;
export const ZOOM_STREET = 16;
export const ZOOM_ADDRESS = 18;

// Icônes
export const ICON_ACTIVE = {
  path:
    "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
  fillColor: "#2ca8ddf1",
  fillOpacity: 1,
  strokeWeight: 1,
  strokeColor: "rgb(31, 121, 160)",
  rotation: 0,
  scale: 1.7
};

export const ICON_INACTIVE = {
  path:
    "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
  fillColor: "rgb(192, 192, 192)",
  fillOpacity: 1,
  strokeWeight: 1,
  strokeColor: "black",
  rotation: 0,
  scale: 1.3
};

export const ICON_HS = {
  path:
    "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
  fillColor: "rgb(192, 192, 192)",
  fillOpacity: 1,
  strokeWeight: 1,
  strokeColor: "black",
  rotation: 0,
  scale: 1.3
};

export const ICON_PAIEMENT_SUR_PLACE = {
  path:
    "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
  fillColor: "rgb(165, 221, 244)",
  fillOpacity: 1,
  strokeWeight: 1,
  strokeColor: "rgb(59, 159, 202)",
  rotation: 0,
  scale: 1.3
};
// #endregion
